module.exports = __webpack_public_path__ + "media/newstyle/images/stars_4-red-f46674fdfa0033451a7c10e3790bdecb.svg";